export enum ItemType {
  UnlabeledItem = 'unlabeledItem',
  LabeledItem = 'labeledItem',
  PlaceholderItem = 'placeholderItem',
}

export interface IUnlabeledItem {
  id: string;
  dndType: ItemType.UnlabeledItem;
  itemLabel?: string;
}

export interface ILabeledItem {
  id: string;
  dndType: ItemType.LabeledItem;
  itemLabel?: string;
}

export interface IPlaceholderItem {
  id: string;
  dndType: ItemType.PlaceholderItem;
  itemLabel?: string;
}

export type ITiedItem = ILabeledItem | IPlaceholderItem;

export type ITiedItems = ITiedItem[];

export type ILabelOrPlaceholderItems = ITiedItems[];

export interface IRankingOrderData {
  unlabeledItems: IUnlabeledItem[];
  labeledOrPlaceholderItems: ILabelOrPlaceholderItems;
}
